<!--
  - Copyright (c) 2023. Haodong JU
  -->

<script>

export default {
  name: 'ProductCard',
  props: {
    oneTime: {},
    name: {},
    desc: {},
    price: {},
    checked: {},
    readOnly: {}
  }
}
</script>

<template>
  <v-card
    class="pa-2 mb-3"
    color="grey lighten-3"
    elevation="0"
    @click="$emit('clickCard')"
  >
    <div
      :style="!$vuetify.breakpoint.mobile ? '' : 'width: 100%;'"
      class="d-flex align-center"
    >
      <div
        :class="!$vuetify.breakpoint.mobile ? 'mr-5' : ''"
        :style="!$vuetify.breakpoint.mobile ? 'width: 60%;' : 'width: 50%;'"
      >
        <div class="text-body-1">
          {{ name }}
        </div>
        <div
          v-if="desc"
          class="text-body-2 mt-1 text--secondary"
          style="max-width: 500px;"
        >
          {{ desc }}
        </div>
      </div>
      <v-spacer />
      <v-card
        :color="!checked?'grey lighten-3': readOnly?'blue lighten-4 black--text':'amber lighten-4 black--text'"
        :style="!$vuetify.breakpoint.mobile ? '' : 'position: relative;'"
        class="d-block overflow-hidden text-body-2 pa-2 px-2"
        elevation="0"
      >
        <div
          :style="!$vuetify.breakpoint.mobile ? '' : 'position: relative;'"
          class="d-flex align-center"
        >
          <template v-if="oneTime !== 'one_time'">
            <div
              class="text-truncate"
              style="position: relative"
            >
              {{ $t('TheLowest') }}
            </div>
            <div
              class="ml-1 text-no-wrap"
              style="position: relative"
            >
              {{ price / 12 | priceDisplay }}
            </div>
            <div
              class="text-truncate"
              style="position: relative"
            >
              /{{ $t('Monthly') }}
            </div>
          </template>
          <template>
            <div
              class="text-no-wrap ml-1"
              style="position:relative;"
            >
              {{ price | priceDisplay }}
            </div>
          </template>
          <v-icon
            v-if="!readOnly"
            class="ml-1"
            small
            @click="$emit('toggle')"
          >
            {{ checked ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
          </v-icon>
        </div>
      </v-card>
    </div>
  </v-card>
</template>

<style scoped>

</style>
